import React, {Component} from 'react';
import { unix_to_datestring, format_number } from '../../../../ClientUtils';
import {Line} from 'react-chartjs-2';
import axios from "axios";
const root_string = require("../../../../config.json")["root_string"];



class PerformanceOverTime extends Component {

  constructor(props) {
    super(props);
    this.state = {
      labels: [],
      TVL_data: []
    };
  }

  componentDidMount() {
    axios
      .get(root_string + '/api/data_api/DefiPulse_TVL')
      .then(res => {
        let labels = [];
        let Overall_data = [];
        for (let datapoint of res.data["data"]) {
          labels.push(unix_to_datestring(datapoint["timestamp"]));
          Overall_data.push(datapoint["tvlUSD"]);
        }
        this.setState({
          labels: labels,
          TVL_data: Overall_data
        })
      })
      .catch(err => {
        console.log("Error getting TVL Data");
      })
  };


  render() {
    const data = {
      labels: this.state.labels,
      datasets: [
        {
          label: 'Overall TVL',
          fill: true,
          lineTension: 0,
          borderWidth: 2.5,
          backgroundColor: 'rgb(45,69,93)',
          borderColor: 'rgb(203,241,243)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgb(203,241,243)',
          pointBackgroundColor: '#cbf1f3',
          pointHoverBackgroundColor: 'rgb(122,194,198)',
          pointHoverBorderColor: 'rgb(203,241,243)',
          pointHoverBorderWidth: 1,
          pointRadius: 0,
          pointHitRadius: 1,
          data: this.state.TVL_data
        }
      ]
    };

    const options = {
      maintainAspectRatio: false,
      tooltips: {
        mode: 'x-axis'
      },
      legend: {
        labels: {
          fontColor: "#8899AC",
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            autoSkip: true,
            callback: function(value, index, values) {
              if (parseInt(value) >= 1000){
                return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return '$' + value;
              }
            }
          },
          scaleLabel: {
            display: true,
            labelString: "TVL (USD)",
            ticks: {
              fontSize: 100,
            },
            fontSize: 18,
          },
          gridLines: {
            display: false
          },
        }],
        xAxes: [{
          type: 'time',
          ticks: {
            autoSkip: true,
          },
          scaleLabel: {
            display: true,
            labelString: "",
            ticks: {
              fontColor: "#8899AC",
              fontSize: 15
            },
            fontColor: "#8899AC",
            fontSize: 18,
          },
          gridLines: {
            display: false
          }
        }]
      }
    }
    return (
      <div className="chart-container" style={
        {
          backgroundColor: "#192734",
          padding: "30px",
          borderRadius: "5px",
        }
      }>
        <h2>Overall TVL (V1 + V2)</h2>
        <Line className="line-chart" data={data} options={options} height={400}/>
      </div>
    );
  }
}

export default PerformanceOverTime;
